<div class="relative min-h-screen flex flex-col">
    <!-- Navbar Start -->
    <app-navbar></app-navbar>
    <!-- Navbar End -->

    <!-- Top Banner Section Start -->
    <div class="mb-10 banner-container">
        <div class="grid grid-cols-12">
            <div class="col-span-12">
                <div class="w-full h-[450px] banner-wrapper">
                    <img src="/assets/images/banners/booking-status-banner.png" alt=""
                        class="object-cover w-full h-full">
                        <div class="flex items-center h-full banner-container-inner">
                            <div class="container mx-auto">
                                <div class="p-[30px] text-center mt-[7em]">
                                    <h1 class="my-0 mb-2 text-[2em] sm:text-5xl md:text-[2.5em] text-white">
                                        <span class="font-bold mr-2">Booking Status</span>
                                    </h1>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Top Banner Section End -->

    <div class="flex-grow">
        <!-- Booking success starts-->
        <section id="success-section"  *ngIf="isSuccess == 'success' && payment_response"
            class="w-full min-h-[100%] py-[2em] flex flex-row justify-center items-center pb-[4em] booking-success-wrapper">
            <div
                class="w-[80%] h-auto bg-white rounded-md booking-success-main flex flex-wrap-reverse justify-center items-center">
                <div class="bg-[#f8fafb] mr-[1em]">
                    <div class="w-full h-auto pt-[2em] px-[2em] booking-success-container">
                        <h2 class="text-[1.8em] text-black font-medium mt-0 mb-0">Booking Confirmed</h2>
                        <p class="text-[1.2em] text-[#646464] font-normal my-[0.5em]">
                            <span class="text-[#677db9] font-medium">{{payment_details_storage.name}}</span> your booking has been confirmed!
                        </p>
                        <div class="payment-details my-3">
                            <div class="flex items-center flex-wrap">
                                <span class="text-[1em] m-0 text-black font-medium mr-4">Hospital :</span>
                                <span
                                    class="sm:text-right text-[0.9em] font-normal text-black">{{payment_details_storage.hospital
                                    ? payment_details_storage.hospital : 'N/A'}}</span>
                            </div>
                        </div>
                        <div class="payment-details my-3">
                            <div class="flex items-center flex-wrap">
                                <span class="text-[1em] m-0 text-black font-medium mr-4">Doctor :</span>
                                <span
                                    class="sm:text-right text-[0.9em] font-normal text-black">{{payment_details_storage.doctor
                                    ? payment_details_storage.doctor : 'N/A'}}</span>
                            </div>
                        </div>
                        <div class="payment-details my-3">
                            <div class="flex items-center flex-wrap">
                                <span class="text-[1em] m-0 text-black font-medium mr-4">Booking Date :</span>
                                <span
                                    class="sm:text-right text-[0.9em] font-normal text-black ">{{appointmentDate
                                    ? ( appointmentDate | date:'MMM d, y' )  : 'N/A'}}</span>
                            </div>
                        </div>
                        <div class="flex items-center mt-[1.2em] mb-0">
                            <mat-icon class="text-2xl mr-2 text-[#677db9] custom-icon-style"
                                *ngIf="payment_response.details.booking_no">task</mat-icon>
                            <h3 class="text-[1.2em] font-medium mt-2 mb-2 text-black">Payment Details</h3>
                        </div>
                        <hr class="mt-1 mb-[2em]">
                    </div>
                    <div class="grid grid-cols-12 gap-4 my-2 px-[2em] content-wrapper">
                        <div class="mr-[0.3em] col-span-12 sm:col-span-6 md:col-span-4">
                            <h3 class="text-[1.1em] m-0 mb-1 text-black font-medium">Payment Date</h3>
                            <div class="flex items-center">
                                <p class="text-[0.9em] text-[#646464] my-2">{{ currentDate | date:'MMM d, y' }}</p>
                            </div>
                        </div>
                        <div class=" col-span-12 sm:col-span-6 md:col-span-4">
                            <h3 class="text-[1.1em] m-0 mb-1 text-black font-medium">Payment Method</h3>
                            <div class="flex items-center mr-[0.5em]">
                                <p class="sm:text-right text-[0.9em] font-normal text-[#646464] my-2">
                                    {{payment_response.details.payment_method ? payment_response.details.payment_method
                                    : 'N/A'}}</p>
                            </div>
                        </div>
                        <div class=" col-span-12 sm:col-span-6 md:col-span-4">
                            <h3 class="text-[1.1em] m-0 mb-1 text-black font-medium">Payment Id</h3>
                            <div class="flex items-center mr-[0.5em]">
                                <p class="text-[0.9em] text-[#646464] my-2">
                                    {{payment_response.details.payment_id ? payment_response.details.payment_id :
                                    'N/A'}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="px-[2em] mt-4 flex items-center ">
                        <h3 class="text-[1.2em] m-0 text-black font-medium mr-5">Total Amount :</h3>
                        <div class="mr-[0.5em] text-black font-medium">
                            <p class="text-[1.1em] text-black m-0 flex">
                                <mat-icon class="custom-icon-style text-[1.1em]">currency_rupee</mat-icon>
                                {{payment_details_storage.amount ? payment_details_storage.amount : 'N/A'}}</p>
                        </div>
                    </div>
                    <div class="px-[2em] pb-[2em]">
                        <div class="flex items-center mt-[1.2em] mb-0">
                            <h3 class="text-[1.2em] font-medium mt-2 mb-2 text-black">Personal Details</h3>
                        </div>
                        <hr class="mt-1 mb-[2em]">

                        <div>
                            <div class="mr-[0.3em] flex flex-col sm:flex-row">
                                <h3 class="text-[1em] m-0 mb-1 text-black font-normal mr-[4em] w-[50px]">Name:</h3>
                                <div class="flex items-center">
                                    <p class="text-[1em] font-normal text-[#2f4965] m-0">{{payment_details_storage.name ?
                                        payment_details_storage.name : 'N/A'}}</p>
                                </div>
                            </div>
                            <div class="mr-[0.3em] flex flex-col sm:flex-row">
                                <h3 class="text-[1em] font-normal m-0 mb-1 text-black mr-[4em] w-[50px]">Email:</h3>
                                <div class="flex items-center">
                                    <p class="text-[1em] font-normal text-[#2f4965] m-0">{{payment_details_storage.email ?
                                        payment_details_storage.email : 'N/A'}}</p>
                                </div>
                            </div>
                            <div class="mr-[0.3em] flex flex-col sm:flex-row">
                                <h3 class="text-[1em] font-normal text-black m-0 mb-1 mr-[4em] w-[50px]">Mobile:</h3>
                                <div class="flex items-center">
                                    <p class="text-sm text-[#2f4965] m-0">{{payment_details_storage?.phone || 'N/A'}}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="booking-payment-details">
                    <div class="w-[350px] h-auto mx-auto my-5 pb-[2em] booking-list-card relative">
                        <div class="py-[2em] px-[1.5em] card-bg rounded-3xl">
                            <div class="mb-5">
                                <h2 class="text-[1.2em] font-normal text-white m-0">Booking No :</h2>
                                <h2 class="text-white text-[1.7em] m-0">{{payment_response.details.booking_no ?
                                    payment_response.details.booking_no : 'N/A'}}</h2>
                            </div>
                            <div>
                                <h2 class="text-[1.2em] font-normal text-white m-0">Token No :</h2>
                                <h2 class="text-white text-[1.7em] m-0">{{payment_response.details.appointmentToken ?
                                    payment_response.details.appointmentToken : 'N/A'}}</h2>
                            </div>
                        </div>
                        <div class="px-[1.5em] payment-details my-3">
                            <div class="flex items-center flex-wrap">
                                <span class="text-[1.1em] m-0 text-black font-medium mr-4">Payment Id :</span>
                                <span
                                    class="text-[1em] text-black font-normal">{{payment_response?.details.payment_id
                                    ? payment_response?.details.payment_id : 'N/A'}}</span>
                            </div>
                        </div>
                        <div class="px-[1.5em] address-sec mt-4 flex items-center flex-wrap">
                            <p class="text-[1em] text-black m-0 mr-4">Date :</p>
                            <p class="text-[0.9em] font-normal text-[#646464] m-0 py-[0.5em]">{{ currentDate | date:'MMM d, y' }}
                            </p>
                        </div>
                        <div class="px-[1.5em] address-sec mt-4 flex items-center flex-wrap">
                            <p class="text-[1em] text-black m-0 mr-4">Address :</p>
                            <p class="text-[0.9em] font-normal text-[#646464] m-0 py-[0.5em]">Medease, Street Road, California
                            </p>
                        </div>
                        <div class="border-t border-gray-300 mx-[1.5em]"></div>
                        <div class="px-[1.5em] payment-details my-5">
                            <div class="flex items-center flex-wrap">
                                <p class="text-[1.2em] m-0 text-black font-medium mr-5">Total Advance Amount: </p>
                                <p class="text-[1.1em] m-0 text-black font-medium flex">
                                    <mat-icon class="custom-icon-style text-[1.1em]">currency_rupee</mat-icon>
                                    {{payment_details_storage ?
                                        payment_details_storage.amount : 'N/A'}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>

            </div>
        </section>


        <!-- Booking failure starts-->
        <section *ngIf="isSuccess == 'failed' && payment_response"
            class="w-full min-h-[100%] py-[2em] flex flex-row justify-center items-center mt-[80px] mb-[100px]">
            <div
                class="w-[80%] md:w-[60%] lg:w-[30%] h-auto py-[2em] bg-white rounded-md relative booking-failed-wrapper shadow-md">
                <div class="h-[100%] flex flex-col">
                    <h4 class="text-center text-[#2f4965] text-xl font-bold my-0">Please try again</h4>
                    <p class="text-center text-sm my-2">Something went wrong</p>
                    <mat-icon
                        class="text-white rounded-full p-[0.5em] text-center flex items-center justify-center">priority_high</mat-icon>
                    <p class="text-center text-[#2f4965] text-base mb-[2em]">We couldn't book the appointment</p>
                    <hr>
                    <div>
                        <div class="w-full flex justify-center">
                            <button class="w-[80%] mt-[1em] text-base custom-btn-style" mat-raised-button
                                color="primary" (click)="failedRedirect()"><span class="text-white">TRY
                                    AGAIN</span></button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Booking failure ends-->
    </div>

    <!-- Footer Start -->
    <app-message></app-message>
    <app-footer></app-footer>
     <!-- Footer End -->
</div>